import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const JanSevaKendra = () => <VerticalPage config={VERTICALS['jan-seva-kendra']} />;

export default JanSevaKendra;
